var formAction = "https://landingreceiver.youandemili.com/api/v1/landing/process/json";
var gdprFormDescriptor = "https://landingreceiver.youandemili.com/api/v1/integrations/cnhgpdr/config";
var genericError = "Nous sommes désolés mais une erreur s'est produite. Nous vous invitons à réessayer plus tard.";
var userExistError = "Adresse e-mail déjà enregistrée. Essayez une autre adresse.";
var successTitle ="Merci d'avoir rempli le formulaire.";
var successMessage = "Vous serez bientôt contacté par le concessionnaire CASE le plus proche.";
var errorMessage = "Ce champ est requis.";
var errorMessageEmail = "S'il vous plaît, mettez une adresse email valide.";
var errorMessagePhone = "Saisissez un numéro de téléphone incluant l'indicatif du pays (Exemple : +33xxxxxxxxx)";
var errorMessageCity = "Les nombres ne sont pas autorisés";

$(document).ready(function () {

  var yr = new Date().getFullYear();
  $("#ae-year").html(yr);

  ViewPortHeight();
  CTAPosition();

  jQuery.validator.addMethod("notNumber", function (value, element, param) {
    var reg = /[0-9]/;
    if (reg.test(value)) {
      return false;
    } else {
      return true;
    }
  }, "Numbers not allowed");

  $("#phonenumber").keypress(function (e) {
    if (String.fromCharCode(e.which).match(/[^+0-9]/)) {
      e.preventDefault();
    }
  });

  $("#city").keypress(function (e) {
    e = e || window.event;
    var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);
    if (/\d/.test(charStr)) {
      e.preventDefault();
    }
  });

  $('.scroll-link').click(function (e) {
    e.preventDefault();
    $(window).stop(true).scrollTo(this.hash, {
      duration: 10,
      offset: 0,
      easing: 'easeOutCirc'
    });
  });

  $("#purchaseintention").on("change", function () {
    $("#purchaseintentionText").val($("#purchaseintention option:selected").text());
  });

  $("#model").on("change", function () {
    $("#modelText").val($("#model option:selected").text());
  });

  $("#country").on("change", function () {
    var $opt = $("#country option:selected");
    console.log("opt", $opt.attr("ae-data-lrn"));
    $("#lid").val($opt.attr("ae-data-lr"));
    $("#landingName").val($opt.attr("ae-data-lrn"));
  });

  /*** select floating label ***/
  $(".form-select").each(function () {
    selectLabel($(this));
  });

  $(".form-select").on("change", function () {
    selectLabel($(this));
  });

  $(".ae-btn-submit").attr("disabled", "disabled");

  configLandigReceiver();
  initRecaptcha();

  if ($("#promo").val() == "pl") {
    //console.log("PL -> GDPR");
    $(".ae-btn-submit").removeAttr("disabled");
    setFormValidationPL();
  } else {
    //console.log("OTHER -> GDPR");
    /** GDPR **/
    GetFormDescriptor();
    setFormValidation();
  }
});


$(document).on('lazyloaded', function (e) {
  var $target = $(e.target);
  var $parent = $target.parent();
  if ($parent.hasClass("ae-img-spinner")) {
    $parent.addClass("ae-loaded");
  }
});

$(window).on("load", function () {
  $(".ae-img-spinner:not(.ae-loaded) .lazyloaded").each(function () {
    $(this).parent().addClass("ae-loaded");
    $(this).addClass("ae-loaded");
  });
});

$(window).on("resize", function () {
  ViewPortHeight();
  CTAPosition();

  var $m = $(".ae-main-container");
  var bg = $m.attr('data-bg');
  if ($m.hasClass("lazyloaded")) {
    if ($(window).width() <= 991) {
      bg = $m.attr('data-bg-mobile');
    }

    var current = $m.css("background-image");
    if (current.indexOf(bg) === -1) {

      $m.css({
        "background-image": 'url(' + bg + ')'
      });

    }
  }
});


/***** FUNCTIONS  *****/

function CTAPosition() { 
  var h = $("header").outerHeight();
  var $cta = $(".ae-title");
  var viewport = $(window).height();
  console.log("header height", h, "viewport", viewport);
  if (h > viewport) { 
    var diff = h - viewport +20;
    $cta.css({
      "bottom": diff+"px"
    });
  } else {
     $cta.css({
      "bottom": ""
    });
  }
}

function ViewPortHeight() {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function selectLabel(s) {
  var lbl = $("label[for='" + s.attr("id") + "']");
  if (s.val() == "") {
    lbl.addClass("d-none");
    s.removeClass("ae-selected")
  } else {
    lbl.removeClass("d-none");
    s.addClass("ae-selected")
  }
}

function setFormValidation() {
  //form validate 
  $("#landing-form").validate({
    invalidHandler: function (form, validator) {
      var errors = validator.numberOfInvalids();
      if (errors) {
        validator.errorList[0].element.focus();
      }
    },
    errorElement: "span",
    rules: {
      city: 'notNumber'
    },
    preferredContact: {
      required: true
    },
    messages: {
      firstname: errorMessage,
      lastname: errorMessage,
      companyname: errorMessage,
      phonenumber: errorMessage,
      postalcode: errorMessage,
      city: {
        required: errorMessage,
        notNumber: errorMessageCity
      },
      country: errorMessage,
      model: errorMessage,
      purchaseintention: errorMessage,
      email: {
        required: errorMessage,
        email: errorMessageEmail
      },
      gdpr_0: errorMessage,
      gdpr_1: errorMessage,
      gdpr_2: errorMessage,
    }
  });
}

function setFormValidationPL() {
  //form validate 
  $("#landing-form").validate({
    invalidHandler: function (form, validator) {
      var errors = validator.numberOfInvalids();
      if (errors) {
        validator.errorList[0].element.focus();
      }
    },
    errorElement: "span",
    rules: {
      city: 'notNumber'
    },
    preferredContact: {
      required: true
    },
    messages: {
      firstname: errorMessage,
      lastname: errorMessage,
      companyname: errorMessage,
      phonenumber: errorMessage,
      postalcode: errorMessage,
      city: {
        required: errorMessage,
        notNumber: errorMessageCity
      },
      country: errorMessage,
      model: errorMessage,
      purchaseintention: errorMessage,

      email: {
        required: errorMessage,
        email: errorMessageEmail
      },
      marketingPhone: errorMessage,
      marketingEmail: errorMessage,
      marketingMessage: errorMessage,
      marketingThirdPhone: errorMessage,
      marketingThirdEmail: errorMessage,
      marketingThirdMessage: errorMessage
    }
  });
}

function configLandigReceiver() {
  //campaign tracking
  var gtmref = getUrlParameter("utm_source");
  var gtmcampaign = getUrlParameter("utm_campaign");
  var gtmmedium = getUrlParameter("utm_medium");
  var gtmcontent = getUrlParameter("utm_content");
  var placement = getUrlParameter("placement");
  var adset = getUrlParameter("adset");
  var campaignname = getUrlParameter("campaign_name");

  if (gtmref != undefined) {
    $("#gtmref").val(gtmref);
  }
  if (gtmcampaign != undefined) {
    $("#gtmcampaign").val(gtmcampaign);
  }

  if (gtmmedium != undefined) {
    $("#gtmmedium").val(gtmmedium);
  }

  if (gtmcontent != undefined) {
    $("#gtmcontent").val(gtmcontent);
  }

  if (placement != undefined) {
    $("#placement").val(placement);
  } else {
    //prova a leggere il campo utm_placement
    var utm_placement = getUrlParameter("utm_placement");
    if (utm_placement != undefined) {
      $("#placement").val(utm_placement);
    }
  }

  if (adset != undefined) {
    $("#adset").val(adset);
  }

  if (campaignname != undefined) {
    $("#campaignname").val(campaignname);
  }

  //final form post
  $("#landing-form").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var form = $("#landing-form");

    if ($("#promo").val() == "pl") {
      $("#gdpr-contact-error").hide();
      var gdpr_email = $("#gdpr_email").is(":checked");
      var gdpr_phone = $("#gdpr_phone").is(":checked");
      var gdpr_sms = $("#gdpr_sms").is(":checked");
      console.log("gdpr_email", gdpr_email);
      console.log("gdpr_phone", gdpr_phone);
      console.log("gdpr_sms", gdpr_sms);
      if (!gdpr_email && !gdpr_phone && !gdpr_sms) {
        console.log("all false");
        $("#gdpr-contact-error").show();
        return;
      }
    } else {
      var gdprMarketing = $("input[name=gdpr_1]:checked").val();
      var gdprMarketingThird = $("input[name=gdpr_2]:checked").val();
      console.log("gdprMarketing", gdprMarketing);
      console.log("gdprMarketingThird", gdprMarketingThird);
      if (gdprMarketing === "1" || gdprMarketingThird === "1") {
        $("#contact_email").val("1");
        $("#contact_phone").val("1");
        $("#contact_sms").val("1");
      } else {
        $("#contact_email").val("0");
        $("#contact_phone").val("0");
        $("#contact_sms").val("0");
      }
    }


    var productInterest = $("label[for='model'").text().replace("*", "") + " " + $("#modelText").val();
    $("#notesfordealer").val(productInterest+" / "+$("label[for='notes'").text().replace("*", "") + ": " + $("#notes").val());

    if (form.valid()) {
      $(".ae-btn-submit").attr("disabled", "disabled");
      $("#waiting-form").removeClass("d-none");

      postData(form);
    }
    return false;
  });
}

function postData(form) {
  var formData = form.serializeArray();

  var jsonData = {
    "url": window.location.href,
    "name": $("#landingName").val(),
    "id": $("#lid").val(),
    "data": objectifyForm(formData)
  };

  //console.log(jsonData);

  //post
  $.ajax({
    async: true,
    type: "POST",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: formAction,
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(jsonData),
    success: function (resp) {
      //console.log(resp);
      var obj = JSON.parse(JSON.stringify(resp));
      if (obj.status === 1) {
        try {

          //Tracciamento del form inviato
          /**** GTM Navigation Event ****/
          if (typeof dataLayer !== "undefined") {

            dataLayer.push({
              "event": "Pageview",
              "pagePath": location.pathname.replace("index.html", "") + "/form-send/",
              "pageTitle": "Forn send | " + $(document).find("title").text()
            });
          }

          showSuccess()
          document.getElementById("landing-form").reset();
          /*** select floating label ***/
          $(".form-select").each(function () {
            selectLabel($(this));
          });

        } catch (err) {
          console.log(err)
          showError(genericError);
        }

        $(".ae-btn-submit").removeAttr("disabled");
        $("#waiting-form").addClass("d-none");
        initRecaptcha();
      } else {

      }
    },
    error: function (err) {
      var obj = JSON.parse(JSON.stringify(err));
      //console.log("ERR");
      //console.log(obj);
      if (obj.status === 400) {
        var objResp = JSON.parse(JSON.stringify(obj.responseJSON));
        console.log(obj.responseJSON);
        if (objResp.status === 3) {
          var em = "";
          //console.log(objResp.validationErrors);
          $.each(objResp.validationErrors, function (k, er) {
            if (er["fieldName"] == "phonenumber") {
              em = em + errorMessagePhone + "<br />";
            }
            if (er["fieldName"] == "email") {
              em = em + errorMessageEmail + "<br />";
            }
          });
          if (em.length == 0) {
            em = genericError;
          }
          showError(em);
        } else
        if (objResp.status === 4) {
          //email esistente
          showError(userExistError);
        } else {
          showError(genericError);
        }
      }
      $(".ae-btn-submit").removeAttr("disabled");
      $("#waiting-form").addClass("d-none");
      initRecaptcha();
    }
  });

}



function getUrlParameter(sParam) {

  var sPageURL = decodeURIComponent(window.location.href.substring(window.location.href.indexOf("?") + 1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};

//create json from form data
function objectifyForm(formArray) {

  var returnArray = {};
  for (var i = 0; i < formArray.length; i++) {
    returnArray[formArray[i]['name']] = formArray[i]['value'];
  }
  return returnArray;
}

function showError(err) {
  bootbox.alert({
    centerVertical: true,
    message: '<h5 class="text-danger text-uppercase"></h5><div class="text-danger">' + err + '</div>'
  });
}

function showSuccess() {
  bootbox.alert({
      centerVertical: true,
      message: '<div id="form-success"><h5 class="text-uppercase ae-lid-form-success">' + successTitle + '</h5><div>' + successMessage + '</div></div>',
    }

  );
}

/**** GDPR ****/

function GetFormDescriptor() {
  $.ajax({
    async: true,
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: gdprFormDescriptor,
    success: function (resp) {
      if (resp != null) {
        $("#gdpr").val(JSON.stringify(resp));
        GenerateFields(resp);
        $(".ae-btn-submit").removeAttr("disabled");
        // setInfoSectionPosition();
      }
    },
    error: function (resp) {
      //console.log(resp)

    }

  });
}

function GenerateFields(x) {
  $.each(x, function (key, val) {
    if (key === "policies") {
      $.each(val, function (index, value) {
        if (value.type === "checkbox") {
          GenerateChecbox(value)
        }

        if (value.type === "radio") {
          GenerateRadio(value)
        }

      });
    }
  });

}

function GenerateChecbox(policy) {
  var html =
    '<div class="form-group form-check">' +
    '<input type="checkbox" class="form-check-input gdpr-checkbox" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '" value="1" ' + (policy.required ? "required" : "") + ' />' +
    '<label class="gdpr-policy-label form-check-label" for="gdpr_' + policy.id + '">' + policy.description + ' *</label>' +
    '</div>' +
    '</div>';

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);

}

function GenerateRadio(policy) {
  var html = ' <div class="form-group"> ' +
    '<div><div class="gdpr-scrollable">' +
    policy.title + " *<br />" + policy.description +
    '<br />' +
    '</div>' +
    '<div class="form-check form-check-inline">' +
    '<input class="form-check-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-0" value="1" required />' +
    '<label class="form-check-label" for="gdpr_' + policy.id + '-0">' + policy.accept_label + '</label>' +
    '</div>' +
    '<div class="form-check form-check-inline">' +
    '<input class="form-check-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-1" value="0" /> ' +
    '<label class="form-check-label" for="gdpr_' + policy.id + '-1">' + policy.deny_label + '</label>' +
    '</div>' +
    '</div></div>'

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);
}

function initRecaptcha() {
  var lang = $("#promo").val().toLowerCase().replace("-", "_");
  if (grecaptcha?.enterprise && $("#recaptcha").length) {
      $(".ae-btn-submit").attr("disabled", "disabled");
      if (this.recaptchaIniting)
          return;
      this.recaptchaIniting = true;
      console.log("initRecaptcha");
      grecaptcha.enterprise.ready(() => {
          console.log("initRecaptcha ready");
          grecaptcha.enterprise.execute('6LcamPoqAAAAALT9aIkdVidWb2gKs_8FXoMNp0J0', { action: "financial_promo_fr"}).then(token => {
              console.log("initRecaptcha new token","financial_promo_fr");
              $("#recaptcha").val(token);
              $(".ae-btn-submit").removeAttr("disabled");
              this.recaptchaIniting = false;
              this.isLoading = false;
          });
      });
      clearInterval(this.recaptchaInterval);
      this.recaptchaInterval = setInterval(() => this.initRecaptcha(), 60 * 2 * 1000);
  } else {
      this.isLoading = false;
  }
}